import CardImg from "../../../components/MyGiftPoints/img/card_sample.png";

type Props = {
  myPoint: string;
  total: string;
};

const COMMISSION_PERCENTAGE = 10;

const calculateTotalPointsWithCommission = (points: string | number) => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return 0;
  }
  return num * (1 + COMMISSION_PERCENTAGE / 100);
};
export const MyGiftPoints = (props: Props) => {
  return (
    <div className="bg-[#FFFCE7] p-[15px]">
      <div className="text-[20px] font-bold text-black mb-[25px]">所持ミライマイル</div>
      <div className="px-[15px]">
        <div className="grid grid-cols-[auto_1fr] grid-rows-[auto_1fr] gap-x-[15px]">
          <div className="w-[80px] row-span-2 h-[80px]">
            <img src={CardImg} alt="" className="w-full h-full object-cover" />
          </div>
          <div className="flex items-center gap-x-[3px] h-[80px]">
            <div className="font-roboto font-bold text-[38px] text-gold-gradient leading-none">{props.myPoint}</div>
          </div>
        </div>
        <div className="border-b border-[#D5AB2A] my-[18px] border-dotted" />
        <div>
          <div className="text-gray text-[12px]">累計の交換マイル</div>
          <div className="font-bold text-[20px]">{calculateTotalPointsWithCommission(props.total)}</div>
        </div>
      </div>
    </div>
  );
};
